import React from "react";
import propTypes from "prop-types";
import {
  Form,
  FormGroup,
  Button,
  Row,
  Col,
  Label,
  Input,
} from "reactstrap";
import SelectFaqCategory from "../../../components/Form/Select/Async/SelectFaqCategory";
import { faqLanguageOptions } from "../constants";

const activeOptions = [
  { value: "", label: "All statuses" },
  { value: "1", label: "Active" },
  { value: "0", label: "Inactive" },
];

const FilterForm = (props) => {
  return (
    <Form className="form-filter" onSubmit={props.onSubmit}>
      <Row>
        <Col xs={12} md={6} style={{ paddingRight: 0 }}>
          <p>Filter By :</p>
          <FormGroup row>
            <Col xs={12} sm={4} md={3}>
              <Label
                className="justify-content-start mb-2"
                style={{ fontWeight: 700 }}
                for="formFaqCategory"
              >
                Category
              </Label>
            </Col>
            <Col xs={12} sm={8} md={9}>
              <SelectFaqCategory
                id="formFaqCategory"
                name="faq_category_id"
                typedLength={0}
                defaultOptions
                id="_formSelectFaqCategory"
                paramsApi={{ sort_by: "createdAt_desc" }}
                placeholder="Select a category..."
                noResultsText="Cannot find faq category."
                value={props.category}
                onSelectChange={(val) => {
                  props.onCategoryInputChange(val);
                }}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col xs={12} sm={4} md={3}>
              <Label className="mb-2" style={{ fontWeight: 700 }}>
                Language
              </Label>
            </Col>
            <Col xs={12} sm={8} md={9}>
              <div className="d-flex ml-2 mr-2" style={{ flexWrap: "wrap" }}>
                {faqLanguageOptions.map((option) => (
                  <FormGroup check className="mr-3" key={option.value || "all-languages"}>
                    <Label check>
                      <Input
                        type="radio"
                        name="language_code"
                        value={option.value}
                        checked={props.language_code === option.value}
                        onChange={props.onInputChange}
                      />{" "}
                      {option.label}
                    </Label>
                  </FormGroup>
                ))}
              </div>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col xs={12} sm={4} md={3}>
              <Label className="mb-2" style={{ fontWeight: 700 }}>
                Status
              </Label>
            </Col>
            <Col xs={12} sm={8} md={9}>
              <div className="d-flex ml-2 mr-2" style={{ flexWrap: "wrap" }}>
                {activeOptions.map((option) => (
                  <FormGroup check className="mr-3" key={option.value || "all-statuses"}>
                    <Label check>
                      <Input
                        type="radio"
                        name="active"
                        value={option.value}
                        checked={props.active === option.value}
                        onChange={props.onInputChange}
                      />{" "}
                      {option.label}
                    </Label>
                  </FormGroup>
                ))}
              </div>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col xs={12} sm={8} md={9}>
              <Button color="primary">Apply</Button>
            </Col>
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};
export default FilterForm;

FilterForm.propTypes = {
  active: propTypes.string,
  language_code: propTypes.string,
  onInputChange: propTypes.func.isRequired,
  onCategoryInputChange: propTypes.func.isRequired,
  onSubmit: propTypes.func.isRequired,
};

FilterForm.defaultProps = {
  active: "",
  category: "",
  language_code: "",
};
